// extracted by mini-css-extract-plugin
export default {"noticeBoardSmall":"NoticeBoardSmall_noticeBoardSmall__iEQHj","title":"NoticeBoardSmall_title__-MPw6","notice_body":"NoticeBoardSmall_notice_body__fSpxK"};